// Page copy for the redesigned Studio. Keep enUS and zhCN structurally identical.
export const enUS = {
  explore: '{count} avatars to explore',
  loadingAvatars: 'Loading avatars',
  emptyTitle: 'No public avatars yet',
  emptyBody: 'Public avatars will appear here when available',
  errorTitle: 'Could not load avatars',
  errorBody: 'Please try again to browse avatars',
  retry: 'Retry',
  preview: 'Preview',
  copyId: 'Copy {name} avatar ID',
  copiedId: 'Copied {name} avatar ID',
  copied: 'Copied',
  detail: {
    back: 'Back to Public Avatars',
    avatarId: 'Avatar ID',
    preview: 'Preview',
    voice: 'Voice',
    changeVoice: 'Change voice',
    showBackground: 'Show background',
    backgroundNote: 'Only affects this preview',
    background: 'Background',
    integrationGuide: 'Integration guide',
    download: 'Download',
    useInApp: 'Use in an app',
    unavailable: 'This avatar is unavailable',
    close: 'Close',
  },
}

export const zhCN = {
  explore: '{count} 个人物可探索',
  loadingAvatars: '正在加载人物',
  emptyTitle: '暂无公共人物',
  emptyBody: '公共人物上线后会显示在这里',
  errorTitle: '人物加载失败',
  errorBody: '请重试以浏览人物',
  retry: '重试',
  preview: '预览',
  copyId: '复制 {name} 的人物 ID',
  copiedId: '已复制 {name} 的人物 ID',
  copied: '已复制',
  detail: {
    back: '返回公共人物',
    avatarId: '人物 ID',
    preview: '预览',
    voice: '声音',
    changeVoice: '更换声音',
    showBackground: '显示背景',
    backgroundNote: '仅影响当前预览',
    background: '背景',
    integrationGuide: '接入指南',
    download: '下载',
    useInApp: '在应用中使用',
    unavailable: '该人物暂不可用',
    close: '关闭',
  },
}
